<template>
  <div class="satoshi-container">
    <img src="~@/assets/images/satoshi-gold.svg" class="satoshi" />
    <p class="satoshi-meet">{{ $t('meet') }}</p>
    <p class="satoshi-title">{{ $t('satoshi') }}</p>
    <p class="satoshi-desc" v-html="$t('satoshi_desc')"></p>
  </div>
</template>
<style scoped>
@media (max-width: 440px) {
  .satoshi-container {
    margin-top: -18.3%;
    height: 89vw;
  }
  .satoshi {
    width: 32%;
    bottom: 98px;
    left: 3%;
  }
  .satoshi-meet {
    top: 25%;
    left: 32%;
  }
  .satoshi-title {
    top: 28%;
    left: 38%;
  }
  .satoshi-desc {
    top: 48%;
    left: 39%;
  }
}
@media (min-width: 440px) {
  .satoshi-container {
    margin-top: -105px;
    height: 469px;
  }
  .satoshi {
    width: 27%;
    bottom: 120px;
    left: 3%;
  }
  .satoshi-meet {
    top: 26%;
    left: 30%;
  }
  .satoshi-title {
    top: 30%;
    left: 38%;
  }
  .satoshi-desc {
    top: 46%;
    left: 41%;
  }
}
@media (min-width: 640px) {
  .satoshi-container {
    margin-top: -140px;
    height: 595px;
  }
  .satoshi {
    width: 27%;
    bottom: 162px;
    left: 3%;
  }
  .satoshi-meet {
    top: 26%;
    left: 30%;
  }
  .satoshi-title {
    top: 30%;
    left: 44%;
  }
  .satoshi-desc {
    top: 46%;
    left: 36%;
  }
}
@media (min-width: 768px) {
  .satoshi-container {
    margin-top: -170px;
    height: 777px;
  }
  .satoshi {
    width: 27%;
    bottom: 210px;
    left: 6%;
  }
  .satoshi-meet {
    top: 26%;
    left: 30%;
  }
  .satoshi-title {
    top: 30%;
    left: 44%;
  }
  .satoshi-desc {
    top: 46%;
    left: 42%;
  }
}
@media (min-width: 1024px) {
  .satoshi-container {
    margin-top: -194px;
    height: 954px;
  }
  .satoshi {
    width: 26%;
    bottom: 285px;
    left: 6%;
  }
  .satoshi-meet {
    top: 26%;
    left: 30%;
  }
  .satoshi-title {
    top: 30%;
    left: 44%;
  }
  .satoshi-desc {
    top: 46%;
    left: 42%;
  }
}
@media (min-width: 1280px) {
  .satoshi-container {
    margin-top: -218px;
    height: 1152px;
  }
  .satoshi {
    width: 27%;
    bottom: 338px;
    left: 4%;
  }
  .satoshi-meet {
    top: 26%;
    left: 32%;
  }
  .satoshi-title {
    top: 31%;
    left: 42%;
  }
  .satoshi-desc {
    top: 50%;
    left: 44%;
  }
}
@media (min-width: 1536px) {
  .satoshi-container {
    margin-top: -278px;
    height: 1430px;
  }
  .satoshi {
    width: 27%;
    bottom: 420px;
    left: 12%;
  }
  .satoshi-meet {
    top: 25%;
    left: 34%;
  }
  .satoshi-title {
    top: 30%;
    left: 36%;
  }
  .satoshi-desc {
    top: 51%;
    left: 52%;
  }
}
.satoshi-container {
  @apply w-full bg-transparent relative;
  background-image: url('~@/assets/images/satoshi-bg.png');
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
}
.satoshi {
  @apply absolute;
}
.satoshi-meet {
  @apply absolute text-black font-black text-base sm:text-3xl lg:text-4xl 2xl:text-5xl italic;
  transform: rotate(-9deg);
  letter-spacing: -0.03em;
}
.satoshi-title {
  @apply absolute text-red-520 font-normal text-4xl sm:text-5xl lg:text-7xl 2xl:text-10xl;
  font-family: Gloss And Bloom;
  transform: rotate(-9deg);
  letter-spacing: -0.03em;
}
.satoshi-desc {
  @apply absolute text-black italic text-center text-sssm sm:text-lg lg:text-xl 2xl:text-2xl;
  font-family: DINPro-CondMedium;
  transform: rotate(-9deg);
}
</style>
